import axios from 'axios'

export const USERS_HAS_ERROR = 'USERS_HAS_ERROR'
export const USERS_IS_LOADING = 'USERS_IS_LOADING'
export const USERS_FETCH_DATA_SUCCESS = 'USERS_FETCH_DATA_SUCCESS'
export const USERS_CREATE_CACHE = 'USERS_CREATE_CACHE';

export function usersHasError(err) {
    return {
        type: USERS_HAS_ERROR,
        error: err
    };
}

export function usersIsLoading(bool) {
    return {
        type: USERS_IS_LOADING,
        isLoading: bool
    };
}

export function usersFetchDataSuccess(users) {
    return {
        type: USERS_FETCH_DATA_SUCCESS,
        users
    };
}

export function usersCreateCache(users) {
    var usersCache = users.reduce(function(hash, value) {
        var key = value['id'];
        hash[key] = value.name;
        return hash;
      }, {});

    return {
        type: USERS_CREATE_CACHE,
        usersCache
    };
}

async function getData() {
    const res = await axios("/user?sort=name");
    return res.data;
  }

export function fetchUsers() {
    return (dispatch) => {
        dispatch(usersIsLoading(true));

        getData()
        .then(response => {
            dispatch(usersIsLoading(false));
            dispatch(usersFetchDataSuccess(response));
            dispatch(usersCreateCache(response));
        })
        .catch(err => 
        {
            dispatch(usersHasError(err));
        })
        }
    }

